export default __webpack_public_path__ + "static/media/SuccessIcon.1ee0dc08.svg";